import { render, staticRenderFns } from "./list.vue?vue&type=template&id=31b547e0"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31b547e0')) {
      api.createRecord('31b547e0', component.options)
    } else {
      api.reload('31b547e0', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=31b547e0", function () {
      api.rerender('31b547e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list/conversations/list.vue"
export default component.exports